import { isTreeField, isTreeOverlay, isTreeSection } from "@/helpers/Misc";
import { defineComponent } from "vue";
import type { PropType } from "vue";
import VRuntimeTemplate from "vue3-runtime-template";

export default defineComponent({
  name: "RecursiveComponent",
  components: {
    VRuntimeTemplate,
  },
  props: {
    level: {
      type: Number,
      default: 1,
    },
    structure: {
      type: Object as PropType<ITreeTable> | Object as PropType<ITreeField> | Object as PropType<ITree>,
      required: true,
      default: {} as ITreeField,
    },
    identifier: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    fetchMetaData(identifier: string) {
      return window.FormEngine.structure.fields.get(identifier);
    },
    asString(value: string | number): string {
      return value as string;
    },
    isTable(elem: any) {
      return isTreeSection(elem)
    },
    isControl(elem: any) {
      return isTreeField(elem);
    },
    isSection(elem: any) {
      return isTreeSection(elem)
    },
    isOverlay(elem: any) {
      return isTreeOverlay(elem);
    },
    getComponentType(fieldData: any): string {
      if(fieldData && fieldData.LDT && fieldData.LDT.FieldType){
        return fieldData.LDT.FieldType 

      }else{
        console.warn("getComponentType not found !",fieldData)
        return "empty-type"
      }
    
    }
  },
});
